import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from './../http-client/http-client.service';
import { environment } from '../../../../environments/environment';

@Injectable()
export class MapsService {

    constructor(
        private http: Http
    ) {
    }

    public getDataLocation(lat, lng) {
        const headers = new Headers();
        const params = new URLSearchParams();
        const options = new RequestOptions({ headers: headers, params: params });
        const url = environment.googleMapsApiUri + 'geocode/json?latlng=' + lat + ',' + lng + '&sensor=false&key=' + environment.googleMapsApiKey;
        return this.http.get(url, options).map(response => response.json())
            .catch(this.handleError);
    }

    public handleError(error: Response) {
        return Observable.throw(error.json().error || 'Server error');
    }

}



// WEBPACK FOOTER //
// ./src/app/main/services/maps/maps.service.ts